import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class AvarezSenfModel extends BaseModel {
  RouteName = "AvarezSenf";
  protected AuthState: boolean = true;

  public async GetAll() {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}`);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }

      throw error.response?.data.message;
    }
  }
  public async SubmitData(data: any) {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).post(`${this.RouteName}`, data);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }

}
